import { Card } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { spacings } from '../../tokens/spacings';
import { theme } from '../../tokens/theme';

export const ShadowCard = styled(Card)`
  border: 1px solid ${theme.light.ui.background.medium};
  border-radius: 4px;

  && {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
  }
`;

export const Content = styled(Card.Content)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.MEDIUM};
  align-items: flex-start;
  flex: 1;
`;
